import type { ShiptoDepositCrud } from '@diamond/shared/schema/shipto-deposit';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import {
  getShiptoDepositTransactionHistories,
  SHIPTO_DEPOSIT_DEFAULT_HISTORY_SIZE,
} from '../queries/shipto-deposit';
import { useAuthStore, useShipToStore } from '../stores';
import { useNominalLebihBayarEnabled } from './useNominalLebihBayarEnabled';

export function getShiptoDepositHistoriesOptions(
  accessToken: string,
  warehouseId: string,
  page: number,
  isNlbEnabled: boolean
) {
  return queryOptions<ShiptoDepositCrud['getTransactionHistories']['response']>(
    {
      queryKey: ['shipto-deposit-histories', warehouseId, page],
      queryFn: () =>
        getShiptoDepositTransactionHistories(
          accessToken,
          warehouseId,
          page,
          SHIPTO_DEPOSIT_DEFAULT_HISTORY_SIZE
        ),
      enabled: isNlbEnabled && !!accessToken && !!warehouseId,
    }
  );
}

export function useShiptoDepositHistories() {
  const accessToken = useAuthStore((state) => state.access_token);
  const warehouseId = useShipToStore((state) => state.selectedShipToId);
  const isNlbEnabled = useNominalLebihBayarEnabled();
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [warehouseId]);

  const query = useQuery(
    getShiptoDepositHistoriesOptions(
      accessToken,
      warehouseId,
      page,
      isNlbEnabled
    )
  );

  return {
    ...query,
    page,
    setPage,
  };
}
